
// Generated from  SettingsManagement.cs

import {ApiRequestAsync} from "./ApiRequest";
import {Promise} from 'es6-promise';
import {InputType,InputText,InputNumber,InputBoolean,InputChoice,InputFile,InputDate,PrivilegeMembership,FileNote,LanguageInfo,RemoveQuery,FilterMode,ValueCaptionPair} from "./Shared";


export function getBrandingAsync(language : string): Promise<BrandingDetailsGroup[]> {
  return ApiRequestAsync<BrandingDetailsGroup[]>('ISettingsManagementApi', 'GetBrandingAsync', language);
}

export function saveBrandingAsync(brandingUpdate : BrandingUpdate): Promise<BrandingDetailsGroup[]> {
  return ApiRequestAsync<BrandingDetailsGroup[]>('ISettingsManagementApi', 'SaveBrandingAsync', brandingUpdate);
}

export function saveLanguagesAsync(languageUpdateInfos : LanguageUpdateInfo[]): Promise<LanguageDetails[]> {
  return ApiRequestAsync<LanguageDetails[]>('ISettingsManagementApi', 'SaveLanguagesAsync', languageUpdateInfos);
}


export function getLanguagesAsync(): Promise<LanguageDetails[]> {
  return ApiRequestAsync<LanguageDetails[]>('ISettingsManagementApi', 'GetLanguagesAsync');
}

export function getCustomScriptContentAsync(): Promise<string>{
	return ApiRequestAsync<string>('ISettingsManagementApi', 'GetCustomScriptContent');
}


import {observable, IObservableArray} from "mobx";

 
export class BrandingDetailsGroup {     
	@observable caption: string = "";    
	details: IObservableArray<BrandingDetail> = observable.array([]);    
	@observable isValid: boolean;    
	@observable validationMessage: string = "";
}
 
export class BrandingDetail {     
	@observable name: string = "";    
	@observable value: InputText = new InputText();    
	@observable file: InputFile = new InputFile();    
	@observable languageDependent: boolean;
}
 
export class BrandingUpdate {     
	language: string = "";    
	updates: BrandingUpdateInfo[] = [];
}
 
export class BrandingUpdateInfo {     
	name: string = "";    
	value: string = "";
}
 
export class LanguageDetails {     
	@observable name: string = "";    
	@observable region: string = "";    
	@observable caption: string = "";    
	@observable isUserInterfaceLanguage: InputBoolean = new InputBoolean();    
	@observable isContentLanguage: InputBoolean = new InputBoolean();
}
 
export class LanguageUpdateInfo {     
	name: string = "";    
	isUserInterfaceLanguage: boolean;    
	isContentLanguage: boolean;
}



export function _ignoreCompilerError_TS6133(x: any) : boolean {
  return (x instanceof InputText) || 
		 (x instanceof InputBoolean) || 
		 (x instanceof InputChoice) || 
		 (x instanceof InputDate) ||
		 (x instanceof InputFile) || 
		 (x instanceof PrivilegeMembership) || 
		 (x instanceof FileNote) || 
		 (x instanceof LanguageInfo) || 
		 (x instanceof RemoveQuery);
}

